export default "/assets/markers/undeliverable_on.png"